const mediaFormats = {
  mp3: 'mp3',
  aac: 'aac',
  ogg: 'ogg',
  flash: 'flash',
  hls: 'hls',
  m3u8: 'm3u8',
};

export default mediaFormats;
